import React from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import set from 'lodash/set'
import isEqual from 'lodash/isEqual'

import { GET } from 'actions/apiActions'
import RegionSelectField from 'components/forms/RegionSelectField'
import { toTitleCase } from 'utils'

export default class StateFeeTaxForm extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      pending: true,
      formSchema: null,
      taxRegionId: this.props.taxRegionId,
      taxRegionLabel: this.props.taxRegionLabel,
      stateFeeTax: Object.assign({}, this.props.stateFeeTax),
      regionConfigurations: {},
    }

    this.loadFormConfig = this.loadFormConfig.bind(this)
    this.inputChangeFn = this.inputChangeFn.bind(this)
  }

  inputChangeFn(path, value) {
    let { stateFeeTax } = this.state,
      currentState = Object.assign({}, stateFeeTax)

    set(currentState, path.join('.'), value)

    this.setState({ stateFeeTax: currentState })
  }

  getRegionLabel(region) {
    if (isEmpty(region)) return

    return toTitleCase(
      [
        region.RegionName,
        region.InCity ? 'In city' : 'Out of city',
        region.SubregionID ? `Subregion: ${region.SubregionID}` : false,
      ]
        .filter(Boolean)
        .join(' - '),
    )
  }

  buildCompoundId(regionConfig) {
    return [
      regionConfig.RegionID,
      regionConfig.InCity ? 'InCity' : 'NotInCity',
      regionConfig.SubregionID,
    ]
      .filter(x => x !== null && x !== undefined)
      .join('-')
  }

  onRegionSelect(taxRegionId, userEdit) {
    let { customerZipCode, regionConfigurations } = this.state,
      { onChange = () => {} } = this.props,
      stateFeeTax = !isEmpty(taxRegionId)
        ? get(regionConfigurations, `${taxRegionId}.StateFeeTax`)
        : {},
      newState = {
        zipCode: customerZipCode,
        customerZipCode,
        taxRegionId,
        stateFeeTax,
        taxRegionLabel: this.getRegionLabel(
          get(regionConfigurations, taxRegionId),
        ),
      }

    if (userEdit) newState.userEdit = true

    this.setState(newState, () => {
      onChange(newState)
      this.onAfterRegionSelect && this.onAfterRegionSelect()
    })
  }

  loadFormConfig(customZip) {
    let { taxFeeOptionsByZip, autoSelect } = this.props,
      { customerZipCode, taxRegionId } = this.state,
      oldRegions = { ...this.state.regionConfigurations },
      zip = customZip || customerZipCode,
      getBestId = () => {
        let kz = Object.keys(this.state.regionConfigurations)

        return kz.includes(taxRegionId) ? taxRegionId : kz[0]
      }

    if (zip && zip.length === 5) {
      taxFeeOptionsByZip(null, { zip }).then((res = {}) => {
        this.setState(
          {
            pending: false,
            formSchema: res.formSchema,
            regionConfigurations: (res.regionConfigurations || []).reduce(
              (ret, config) => ({
                ...ret,
                [this.buildCompoundId(config)]: config,
              }),
              {},
            ),
          },
          () => {
            if (
              (!isEmpty(oldRegions) &&
                !isEqual(oldRegions, this.state.regionConfigurations)) ||
              autoSelect
            )
              this.onRegionSelect(getBestId(), false)
          },
        )
      })
    }
  }

  getRegionSelectField(allowAutoTaxRate, fieldProps) {
    let {
        customerZipCode,
        taxRegionId,
        regionConfigurations = {},
      } = this.state,
      { force, size, rounded = true } = this.props

    allowAutoTaxRate = allowAutoTaxRate || this.props.allowAutoTaxRate

    return customerZipCode &&
      customerZipCode.length === 5 &&
      (force ||
        allowAutoTaxRate ||
        Object.keys(regionConfigurations).length > 0) ? (
      <RegionSelectField
        {...fieldProps}
        size={size}
        rounded={rounded}
        taxRegionId={taxRegionId}
        regionConfigurations={regionConfigurations}
        onChange={({ target }) => this.onRegionSelect(target.value, true)}
        allowAutoTaxRate={allowAutoTaxRate}
      />
    ) : null
  }

  static getDerivedStateFromProps(newProps, oldState) {
    return {
      ...oldState,
      ...newProps,
      customerZipCode: newProps.zip,
    }
  }

  componentDidUpdate(oldProps) {
    if (this.props.zip !== oldProps.zip) {
      this.setState({ pending: true }, this.loadFormConfig)
    }
  }

  componentDidMount() {
    this.loadFormConfig()
  }

  render() {
    return this.getRegionSelectField()
  }
}

export const ConnectedStateFeeTaxForm = connect(
  (_, op) => ({ ...op }),
  {
    taxFeeOptionsByZip: GET.taxFeeOptionsByZip,
  },
)(StateFeeTaxForm)
